import axios from 'axios';

const INSTALMENTS_URI = 'checkout/api/v1/wallet/installments';

export function installments(request) { 
  return new Promise((resolve, reject) => {
    axios
      .post(INSTALMENTS_URI, request)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}


// WEBPACK FOOTER //
// ./src/services/installments/InstallmentService.js